import React, { Component, createRef } from "react";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import Selector from "../../components/dropdown/commonDropdown/Selector.js";
import ProductionServices from "../../services/axioServices/apiServices/ProductionServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import moment from "moment";
import * as XLSX from "xlsx";
import MultiSelectDropdown from "../../components/dropdown/MultiSelectDropdown.js";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getAuthProps } from "../../utils/AuthenticationLibrary.js";
import { printFunction } from "../../components/print/printTemplate.js";

class PendingProductionPlanningReport extends Component {
  constructor(props) {
    super(props);
    this.printRef = createRef();
    this.productionServices = new ProductionServices();
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.state = {
      companyName: '',
      tableStatus: "",
      itemGroupLisitng: [],
      noItemFound: "",
      productionPlanningList: [],
      filterDetails: {
        partyName: "",
        productName: "",
        filterBy: "",
        productionStageId: [1],
        searchBy: "",
      },
    };
  }


  componentDidMount() {
    this.getAllPendingProductionPlanningReport();
    const company = getAuthProps()
    this.setState({ companyName: company?.companyName })
  }

  getAllItemGroups = () => {
    this.commonServices.getAllItemCategory().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.categoryName,
          value: item._id,
        }));
        this.setState(
          { itemGroupLisitng: dropdownItems });
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  setFilterParameters = (selected) => {
    let value = selected.label;
    let details = this.state.filterDetails
    details.searchBy = value
    this.setState({ filterDetails: details });
  };

  getAllPendingProductionPlanningReport = () => {
    this.setState({ tableStatus: "Loading..." }, () => {
      let request = this.state.filterDetails;
      this.productionServices.getAllPendingProductionPlanningReport(request).then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          if (response.responseData.length === 0) {
            this.setState({ tableStatus: "No Record Found" })
          } else {
            this.setState({ tableStatus: "" })
          }
          let res = response.responseData;
          const today = new Date();
          res.forEach(item => {
            const planningDate = new Date(item.planningDate);
            const differenceInTime = planningDate - today;
            const differenceInDays = Math.ceil(differenceInTime / (1000 * 60 * 60 * 24));
            item.days = differenceInDays;
          });
          this.setState({ productionPlanningList: res }, () => {
            this.getAllItemGroups();
          });
        } else {
          this.setState({ tableStatus: "" })
          this.getAllItemGroups();
          this.SwalServices.Error(
            response.Message
          );
        }
      });
    })
  }

  render() {
    return (
      <div className="pendingProductionPlanningReport-page">
        {/* 1. Item serach  */}
        <div className="item-search">
          <div className="item-grp flex gap-2.5 mb-2.5">
            <div className="search-grp w-[30%]">
              <label>Category</label>
              <MultiSelectDropdown
                drpIdentity="categoryId"
                options={this.state.itemGroupLisitng}
                closeMenuOnSelect={true}
                hideSelectedOptions={true}
                onChange={(selected) =>
                  this.setFilterParameters(selected, "searchBy")
                }
                allowSelectAll={false}
                value={this.state.itemGroupLisitng.find(
                  (party) =>
                    party.value === this.state.filterDetails.searchBy
                )}
              />
            </div>
            <button
              className="search-btn mt-auto"
              onClick={() => this.getAllPendingProductionPlanningReport()}
            >
              Search
            </button>
            {this.state.productionPlanningList && this.state.productionPlanningList.length > 0 ? (
              <button
                class="print-btn mt-auto"
                onClick={() => printFunction()}
              >
                Print
              </button>
            ) : null}
          </div>
        </div>
        {/* 2. Item tabel  */}
        <div className="itemList-table">
          <div className="hidden print-title">
            <h4>Pending Production Plannig</h4>
            {this.state.filterDetails.searchBy !== "" ? <p className="text-black">Category type:- {this.state.filterDetails.searchBy}</p> : null}
          </div>
          <div className="table-container" style={{ height: "calc(100vh - 125px)" }}>
            <table className="itemList">
              <thead>
                <tr>
                  <td className="w-[3%] no-print">Sr</td>
                  <td className="w-[7%]">Prod. No</td>
                  <td className="w-[10%]">Prod. Date</td>
                  <td className="w-[15%]">Product Name</td>
                  <td className="w-[8%] no-print">Size</td>
                  <td className="w-[8%] no-print">Color</td>
                  <td className="w-[6%] no-print">Weight</td>
                  <td className="w-[8%]">Batch No</td>
                  <td className="w-[8%]">Bt. Size</td>
                  <td className="w-[5%]">Days</td>
                  <td className="w-[8%]">Packing</td>
                  <td className="w-[6%]">Rate</td>
                  <td className="w-[8%]">M.R.P</td>
                </tr>
              </thead>
              <tbody>
                {this.state.productionPlanningList && this.state.productionPlanningList.length > 0
                  ? this.state.productionPlanningList.map((item, key) => (
                    <tr key={key}>
                      <td className="no-print">{key + 1}</td>
                      <td>{item.productionNo}</td>
                      <td>{moment(item.productionPlanningDate).format("DD MMM yyyy")}</td>
                      <td>{item.productId.productName}</td>
                      <td className="no-print">{item.productId.sizeName}</td>
                      <td className="no-print">{item.productId.color}</td>
                      <td className="no-print">{item.productId.weight}</td>
                      <td>{item.batchNo}</td>
                      <td>{item.batchSize}</td>
                      <td>{item.days}</td>
                      <td>{item.packing}</td>
                      <td>{item.salesRate}</td>
                      <td>{item.mrp}</td>
                    </tr>
                  ))
                  : this.state.productionPlanningList &&
                    this.state.productionPlanningList.length === 0
                    && this.state.tableStatus !== "" ? (
                    <tr>
                      <td colSpan={13} style={{ textAlign: "center", fontSize: "16px" }}>
                        {this.state.tableStatus}
                      </td>
                    </tr>
                  ) : this.state.productionPlanningList &&
                    this.state.productionPlanningList.length === 0
                    && this.state.tableStatus === "" ? null : ""}
              </tbody>
            </table>
          </div>
        </div>

        {/*----- Print layout -----*/}
        <div className='table-print mt-5 hidden' id="printableArea">
          {/* Header */}
          <div className="print-header">
            <table className="hdr-table">
              <tbody>
                <tr>
                  <td>
                    <div className="co-name">{this.state.companyName}</div>
                    <div className="rpt-sub">Material Requirment Report [PM]</div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="rule-thick" />
            <div className="rule-thin" />
          </div>


          <div className="print-content">

            {/* <div className="info-row">
                                              <div>
                                                <span className="info-label">Item Name:</span>
                                                <p className="info-value">Paracetamol</p>
                                              </div>
                                            </div> */}

            {/* Table */}
            <table className="data-tbl">
              <colgroup>
                <col style={{ width: "6%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "30%" }} />
                <col style={{ width: "11%" }} />
                <col style={{ width: "8%" }} />
                <col style={{ width: "6%" }} />
                <col style={{ width: "12%" }} />
                <col style={{ width: "8%" }} />
                <col style={{ width: "9%" }} />
              </colgroup>


              <thead>
                <tr>
                  <th style={{ textAlign: 'left' }}>
                    Prod. No
                  </th>
                  <th style={{ textAlign: 'left' }}>
                    Prod. Date
                  </th>
                  <th style={{ textAlign: 'left' }}>
                    Product Name
                  </th>
                  <th style={{ textAlign: 'left' }}>
                    Batch No
                  </th>
                  <th style={{ textAlign: 'left' }}>
                    Bt. Size
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Days
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Packing
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Rate
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    M.R.P
                  </th>
                </tr>
              </thead>

              <tbody>
                {this.state.productionPlanningList && this.state.productionPlanningList.length > 0
                  ? this.state.productionPlanningList.map((item, key) => (
                    <tr key={key}>
                      <td style={{ textAlign: 'left' }}>
                        {item.productionNo}
                      </td>
                      <td style={{ textAlign: 'left' }}>
                        {moment(item.productionPlanningDate).format("DD MMM yyyy")}
                      </td>
                      <td style={{ textAlign: 'left' }}>
                        {item.productId.productName}
                      </td>
                      <td style={{ textAlign: 'left' }}>
                        {item.batchNo}
                      </td>
                      <td style={{ textAlign: 'left' }}>
                        {item.batchSize}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {item.days}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {item.packing}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {item.salesRate}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {item.mrp}
                      </td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan="9" style={{ textAlign: 'center' }}>
                        No Data Found
                      </td>
                    </tr>
                  )}
              </tbody>
            </table>
          </div>

          {/* Footer */}
          <div className="print-footer">
            <div className="rule-foot">
              <table className="foot-tbl">
                <tbody>
                  <tr>
                    <td>* System generated report. No signature required.</td>
                    <td style={{ textAlign: "right" }}>
                      Printed: {new Date().toLocaleDateString("en-GB")} {new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PendingProductionPlanningReport;
